import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  selector: 'app-custom-pagination',
  imports: [PaginationModule, FormsModule],
  templateUrl: './custom-pagination.component.html',
  styles: ''
})
export class CustomPaginationComponent {
  @Input() totalPages: number = 0;
  @Input() totalItems: number = 0;
  @Input() currentPage: number = 1;
  @Input() itemsPerPage: number = 5;
  @Output() pageChanged = new EventEmitter<number>();
  @Output() itemsPerPageChanged = new EventEmitter<number>();

  // Costante per identificare "mostra tutti"

  // Opzioni del dropdown - usando numeri per semplicità
  readonly pageSizeOptions = [
    { value: 5, label: '5' },
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
    { value: 500, label: '500' }
  ];

  emitPagedItemsChange(currentPage: number) {
      this.pageChanged.emit(currentPage);
  }

  emitPageSizeChanged(pageSize: any) {
    this.itemsPerPageChanged.emit(pageSize);
    }
}
